import { IApplicationState, TCardId } from '../../../../../../../../../types/types';
import { ICardSubcard } from '../../../components/CardSubcards/types';
import {
    getAuthUserIsHideSubcards
} from '../../../../../../../../../store/model/authUser/selectors/getAuthUserIsHideSubcards';
import { getBoardIdByCardId } from '../../../../../../../../../store/model/selectors/getBoardIdByCardId';
import { getCardIsEpic } from '../../../../../../../../../store/model/selectors/getCardIsEpic';
import { getCardFullNameHelper } from '../../../../../../../../../store/model/card/helpers/getCardFullNameHelper';
import { stripHtml } from '../../../../../../../base/helpers/stripHtmlHelper';
import { markdown } from '../../../../../../../../../helper/markdownHelper';
import { root } from '../../../../../../../../../store/constants';
import { getSubcardWeight } from '../../../../../../../../../store/model/selectors/getSubcardWeight';
import { ICard } from '../../../../../../../../../store/model/card/types';

export const getKnbCardSubcards = (
    state: IApplicationState,
    cardId: TCardId,
    subCards: ICard[],
): ICardSubcard[] => {
    const boardId = getBoardIdByCardId(state, cardId);
    return subCards.map((card) => {
        const isEpic = getCardIsEpic(state, card.id);
        const cardFullName = getCardFullNameHelper(card);
        return {
            ...card,
            fullName: stripHtml(markdown(cardFullName)),
            icon: 'card', // KNB-3875 не имет смысла показывать разные иконки, никакой пользы не дает
            isEpic,
            link: root.App.router.getCardPageUrl(boardId, card.id),
            weight: getSubcardWeight(state, card.id)
        };
    });
};

export const getKnbCardHideDoneFilteredSubcards = (
    state: IApplicationState,
    subcards: ICardSubcard[],
): ICardSubcard[] => {
    const isHideDoneSubcards = getAuthUserIsHideSubcards(state);
    if (!isHideDoneSubcards)
        return subcards;

    const filteredElements = subcards.filter(item => {
        return !!item && !(item.processingStatus === 'done' || item.processingPercent === 100);
    });
    return filteredElements;
};
